(function() {
	'use strict';

	angular.module('quantixApp').controller('MappingWithRISSController',
			MappingWithRISSController);

	MappingWithRISSController.$inject = [ '$scope','MappingWithRissService','$uibModalInstance','ClientListService','$stateParams',
			 '$rootScope','AlertService' ];

	function MappingWithRISSController($scope,MappingWithRissService,$uibModalInstance,ClientListService,$stateParams,$rootScope,AlertService
			) {
		$scope.errorMessage="";
		$scope.clear = function() {
			$uibModalInstance.dismiss('cancel');
		}
		$scope.saveMappingProducts=function(){
			if($scope.productId==undefined){
				$scope.errorMessage="Please select product";
				return;
			}
			else{
				$scope.errorMessage="";
				$scope.mappedData = {
						productName:$scope.rissProductId,
						productId:$scope.productId,
						clientId:$scope.clientId
				}
				MappingWithRissService.saveMappingOfRissWithDataProducts($scope.mappedData).then(function(result){
					
					$uibModalInstance.dismiss('close');
				})
			}
		}
		
	}

})();